window.addEventListener('load', function() {
    var loader = document.getElementById('loader-wrapper');
    if(!loader) return;
    loader.style.transition = "opacity 0.5s ease";
    loader.style.opacity = "0";
    setTimeout(function() {
        loader.style.display = "none";
    }, 500);
});

$(window).on('load resize', function() { 
    if($(window).width() < 1200){
        $('.remove-in-mobile').remove(); 
        $('header .top_bar .search input').attr('placeholder', 'Search')
    }    
});

$(document).ready(function () {   
    
    $('.select').select2({
        width: '100%',
        placeholder: 'Select an option',
    });  

    // Check if screen is mobile
    function isMobile(width) {
        return $(window).width() < width;
    }
    /*_________________________________________________________*/
    // -----------------Swiper Settings & Init----------------------//
    const addSwiperClasses = (element, index) => {
        $(element).find('.swiper').addClass('s' + index);
        $(element).find('.swiper-button-next-custom').addClass('s' + index);
        $(element).find('.swiper-button-prev-custom').addClass('s' + index);
    }

    var headerNavSlider = new Swiper("header .navbar .swiper", {    
        slidesPerView: 'auto',
        spaceBetween: 0,  
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true, 
        slidesOffsetAfter: 60,
        observer: true,
        resizeObserver: true,
        breakpoints: {
            1200: { 
                slidesOffsetAfter: 0,
            },
        },        
    });

    var hero_slider = new Swiper(".homeHero .heroSlider .swiper", {      
        slidesPerView: 1,
        spaceBetween: 10,     
        pagination: {
          el: ".swiper-pagination",
          // dynamicBullets: true,
        },
        autoplay: {
            delay: 2000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
        },
    });

    var hero_categories = new Swiper(".homeHero .category_slider .swiper", {    
        slidesPerView: 2.1,
        spaceBetween: 0,   
        breakpoints: {
            600: {
                slidesPerView: 3,  
            },
            800: {
                slidesPerView: 5, 
            },
            1100: {
                slidesPerView: 5, 
            },
            1300: {
                slidesPerView: 6,  
            },
            1600: {
                slidesPerView: 8, 
            },
        },        
    });

    
    $('.product_slider').each(function (index) {
        addSwiperClasses(this, index)

        var productSlider = new Swiper(".product_slider .swiper.s" + index, {
            direction: 'horizontal',
            loop: false,       
            observer: true,
            observeParents: true,
            slidesPerView: 2.1,
            spaceBetween: 2,   
            navigation: {
                nextEl: '.swiper-button-next-custom' + '.s' + index,
                prevEl: '.swiper-button-prev-custom' + '.s' + index,
            }, 
            breakpoints: {
                700: {
                    slidesPerView: 2.4,
                    spaceBetween: 3,   
                },
                1000: {
                    slidesPerView: 3,
                    spaceBetween: 6,   
                },
                1300: {
                    slidesPerView: 4,
                },
                1600: {
                    slidesPerView: 5,
                }
            },
        });          
    });

    $('.recipe_slider').each(function (index) {
        addSwiperClasses(this, index)

        var recipeSlider = new Swiper(".recipe_slider .swiper.s" + index, {
            direction: 'horizontal',
            loop: false,       
            observer: true,
            observeParents: true,
            slidesPerView: 1.5,
            spaceBetween: 10,   
            navigation: {
                nextEl: '.swiper-button-next-custom' + '.s' + index,
                prevEl: '.swiper-button-prev-custom' + '.s' + index,
            },
            breakpoints: {
                700: {
                    slidesPerView: 2.1,
                    spaceBetween: 10, 
                },
                1000: {
                    slidesPerView: 3,
                    spaceBetween: 20, 
                },
                1600: {
                    slidesPerView: 4,
                    spaceBetween: 20, 
                }
            },
        });          
    });

    var productFilterSilder = new Swiper(".category_title .slider .swiper", {    
        slidesPerView: 'auto',
        spaceBetween: 10,  
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,  
        slidesOffsetAfter: 160,   
        observer: true,
        resizeObserver: true,
        breakpoints: {
            1200: {
                slidesOffsetAfter: 0,
            },
        }, 
    });

    var product_hero_slider = new Swiper(".product_hero .product_thumbnail_slider .swiper", {        
        slidesPerView: 1,
        spaceBetween: 10,      
        pagination: {
          el: ".swiper-pagination",
        },
        observer: true,
        observeParents: true,
    });

    var recipeFilterSilder = new Swiper(".recipe_large_slider .title .slider .swiper", {    
        slidesPerView: 'auto',
        spaceBetween: 10,  
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,  
        slidesOffsetAfter: 160,   
        observer: true,
        resizeObserver: true,
        breakpoints: {
            1200: {
                slidesOffsetAfter: 0,
            },
        }, 
    });
    var reciper_large_slider = new Swiper(".recipe_large_slider .main_slider .swiper", {      
        slidesPerView: 1,
        spaceBetween: 0,  
        observer: true,
        resizeObserver: true,
        navigation: {
            nextEl: '.swiper-button-next-custom-recipe',
            prevEl: '.swiper-button-prev-custom-recipe',
        }, 
    });

    var product_option_slider = new Swiper(".product_hero_details .product_options .swiper", {      
        slidesPerView: 2.10,
        spaceBetween: 10,  
        observer: true,
        resizeObserver: true,
        breakpoints: {
            700: {
                slidesPerView: 2.80,
                spaceBetween: 10, 
            },
            1200: {   
                slidesPerView: 3, 
                spaceBetween: 16, 
            },
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
    });

    var events_product_range_slider = new Swiper(".events_hero .featured_event .event_products .swiper", {      
        slidesPerView: 2.25,
        spaceBetween: 10,  
        observer: true,
        resizeObserver: true,
        breakpoints: {
            600: {
                slidesPerView: 3.25,
                spaceBetween: 10, 
            },
            900: {
                slidesPerView: 4.25,
                spaceBetween: 10, 
            },
            1200: {   
                slidesPerView: 4, 
                spaceBetween: 10, 
            },
            1600: {   
                slidesPerView: 5, 
                spaceBetween: 10, 
            },
            2000: {   
                slidesPerView: 6, 
                spaceBetween: 10, 
            },
        }
    });

    
    /*_________________________________________________________*/
    // -------------Accordion Settings & Init-------------------//
    // Initially hide all accordion content
    $('.accordContent').hide();
    
    // Handle accordion tab clicks
    $('.accordTab').click(function() {
        var $currentItem = $(this).parent('.accordItem');
        var $currentContent = $(this).next('.accordContent');
        var $currentSVG = $(this).find('svg');
        
        // Check if current item is already open
        if ($currentContent.is(':visible')) {
            // Close current item
            $currentContent.slideUp(300);
            $currentSVG.removeClass('rotated');
        } else {
            // Close all other items
            $('.accordContent').slideUp(300);
            $('.accordTab svg').removeClass('rotated');
            
            // Open current item
            $currentContent.slideDown(300);
            $currentSVG.addClass('rotated');
        }
    });


    

    $('.global-overlay').click(function() {        
        $('.megamenu').removeClass('open');
        $('.global-overlay').removeClass('open');
        $('.megamenu .level_one, .megamenu .level_two').removeClass('open sub-level-open');
    });

    // Close megamenu when clicking inside it but outside level divs
    $('.megamenu').click(function(e) {
        // Check if click target is not within level_zero, level_one, or level_two
        if (!$(e.target).closest('.level_zero, .level_one, .level_two').length) {
            $('.megamenu').removeClass('open');
            $('.global-overlay').removeClass('open');
        }
    });
    $('.js-open-megamenu').click(function() {
        if (!isMobile(780)){
            if($('.megamenu').hasClass('open')){
                $('.megamenu').removeClass('open');
                $('.global-overlay').removeClass('open');
                // Reset drawers on close
                $('.megamenu .level_one, .megamenu .level_two').removeClass('open sub-level-open');
            } else {
                $('.megamenu').addClass('open');
                $('.global-overlay').addClass('open');
        
                // Open first path: L0 -> First L1 -> First L2
                var $firstL0 = $('.megamenu .level_zero ul li:first-child a');
                var drawerIdL1 = $firstL0.data('drawer-id');
                var $levelOne = $('.megamenu .level_one[data-drawer-id="' + drawerIdL1 + '"]');
                
                $levelOne.addClass('open');
        
                var drawerIdL2 = $levelOne.find('ul li:first-child a').data('drawer-id');
                if (drawerIdL2) {
                    $('.megamenu .level_two[data-drawer-id="' + drawerIdL2 + '"]').addClass('open');
                    $levelOne.addClass('sub-level-open');
                }
            }
        }else{
            if($('.megamenu').hasClass('open')){
                $('.megamenu').removeClass('open');
                $('.global-overlay').removeClass('open');
            } else {
                $('.megamenu').addClass('open');
                $('.global-overlay').addClass('open');
            }
        }
    });

    // Common close function
    function closeOverlay(target) {
        $('.global-overlay').removeClass('open');        
        $('.global-overlay').css('z-index', '99');
        $(target + ' .cart_inner, ' + target + ' .filter_inner').removeClass('open'); 
        setTimeout(() => {
            $(target).removeClass('open');
        }, 500);
    }

    // Desktop: Level Zero hover - opens corresponding L1 AND first L2
    $('.megamenu .level_zero ul li').on('mouseenter', function() {
        if (isMobile(1200)) return; 
        
        var drawerId = $(this).find('a').data('drawer-id');
        
        // Clear previous states
        $('.megamenu .level_one, .megamenu .level_two').removeClass('open sub-level-open');
        
        // Open targeted Level One
        var $levelOne = $('.megamenu .level_one[data-drawer-id="' + drawerId + '"]');
        $levelOne.addClass('open');

        // Automatically find and open the first Level Two item for this category
        var firstL2Id = $levelOne.find('ul li:first-child a').data('drawer-id');
        if (firstL2Id) {
            $('.megamenu .level_two[data-drawer-id="' + firstL2Id + '"]').addClass('open');
            $levelOne.addClass('sub-level-open');
        }
    });

    // Desktop: Level One items hover - switch Level Two but keep Level One open
    $('.megamenu .level_one ul li').on('mouseenter', function() {
        if (isMobile(1200)) return; 
        
        // Specifically look for the anchor tag to get the ID
        var drawerId = $(this).find('a').attr('data-drawer-id') || $(this).find('a').data('drawer-id');
        var $parentL1 = $(this).closest('.level_one');
        
        if (drawerId) {
            var $targetL2 = $('.megamenu .level_two[data-drawer-id="' + drawerId + '"]');
            
            if ($targetL2.length) {
                // 1. Hide all other level twos
                $('.megamenu .level_two').removeClass('open');
                
                // 2. Open the specific level two matched to this hover
                $targetL2.addClass('open');
                
                // 3. Ensure the parent level one knows a sub-level is active
                $parentL1.addClass('sub-level-open');
            }
        }
    });

    // Desktop: Level Two hover - maintain parent state
    $('.megamenu .level_two').on('mouseenter', function() {
        if (isMobile(1200)) return; 
        $(this).addClass('open');
        
        var drawerId = $(this).data('drawer-id');
        $('.megamenu .level_one ul li a[data-drawer-id="' + drawerId + '"]')
            .closest('.level_one')
            .addClass('sub-level-open');
    });

    // Mobile: Click handler for Level Zero items
    $('.megamenu .level_zero ul li.has_next').on('click', function(e) {
        var width = $(window).width();
        if (width >= 1200) return; // Let hover handle desktop
    
        e.preventDefault();
        e.stopPropagation();
        
        var drawerId = $(this).find('a').data('drawer-id');
        var $levelOne = $('.megamenu .level_one[data-drawer-id="' + drawerId + '"]');
    
        // Reset current state
        $('.megamenu .level_one, .megamenu .level_two').removeClass('open sub-level-open');
    
        // Logic for 780px to 1199px (Tablet: Open L1 AND First L2)
        if (width >= 780) {
            $levelOne.addClass('open');
            var firstL2Id = $levelOne.find('ul li:first-child a').data('drawer-id');
            if (firstL2Id) {
                $('.megamenu .level_two[data-drawer-id="' + firstL2Id + '"]').addClass('open');
                $levelOne.addClass('sub-level-open');
            }
        } 
        // Logic for below 780px (Mobile: Open L1 only)
        else {
            $levelOne.addClass('open');
        }
    });

    // Mobile: Click handler for Level One items
    $('.megamenu .level_one ul li.has_next').on('click', function(e) {
        var width = $(window).width();
        if (width >= 1200) return; // Let hover handle desktop
    
        e.preventDefault();
        e.stopPropagation();
        
        var drawerId = $(this).find('a').data('drawer-id');
        if (drawerId) {
            var $levelTwo = $('.megamenu .level_two[data-drawer-id="' + drawerId + '"]');
            
            if ($levelTwo.length) {
                $('.megamenu .level_two').removeClass('open');
                $levelTwo.addClass('open');
                $(this).closest('.level_one').addClass('sub-level-open');
            }
        }
    });

    // Mobile: Back to main menu
    $('.js-back-to-main').on('click', function(e) {
        if (!isMobile(780)) return; // Skip on desktop
        
        e.preventDefault();
        $(this).closest('.level_one').removeClass('open sub-level-open');
        $('.megamenu .level_two').removeClass('open');
    });

    // Mobile: Back to previous menu (from level_two to level_one)
    $('.js-back-to-prev').on('click', function(e) {
        if (!isMobile(780)) return; // Skip on desktop
        
        e.preventDefault();
        $(this).closest('.level_two').removeClass('open');
        $('.megamenu .level_one').removeClass('sub-level-open');
    });
    
    // Open handlers
    $('.js-open-cart').click(function(e) {
        e.stopPropagation();
        $('#toast-container').html('')
        $('.global-overlay').css('z-index', '106');
        $('.global-overlay').addClass('open');        
        $('.cart').addClass('open');
        setTimeout(() => {
            $('.cart .cart_inner').addClass('open'); 
        }, 100);
    });
    
    $('.js-open-filters').click(function(e) {
        e.stopPropagation();
        $('.global-overlay').css('z-index', '106');
        $('.global-overlay').addClass('open');   

        $('.product_filter .filter_content .filter_accordion .accordItem .accordContent').hide();
        
        if ($(this).attr('data-filter')) {
            var filterValue = $(this).attr('data-filter');
            $('.product_filter .filter_content .filter_accordion .accordItem[data-filter="' + filterValue + '"] .accordContent').show();
        }
             
        $('.product_filter').addClass('open');
        setTimeout(() => {
            $('.product_filter .filter_inner').addClass('open'); 
        }, 100);
     });
    
    // Close handlers
    $('.js-close-cart').click(function() {
        closeOverlay('.cart');
    });
    
    $('.js-close-filters').click(function() {
        closeOverlay('.product_filter');
    });
    
    // Outside click handler
    $(document).on('click', function(e) {
        // Check cart
        if ($('.cart .cart_inner').hasClass('open') && 
            !$(e.target).closest('.cart .cart_inner, .js-open-cart, .js-close-cart').length) {
            closeOverlay('.cart');
        }
        
        // Check filters
        if ($('.product_filter .filter_inner').hasClass('open') && 
            !$(e.target).closest('.product_filter .filter_inner, .js-open-filters, .js-close-filters').length) {
            closeOverlay('.product_filter');
        }
    });   

    $('.js-open-account-mobile-menu').on('click', function(e) {
        e.preventDefault();
        $('.accounts_sidebar').addClass('open');
    });

    // Define the adjustment logic
    const adjustHeroHeight = () => {
        // Ensure element exists and we are not on mobile
        // (Assuming isMobile() is defined elsewhere in your code)
        if ($('.homeHero').length > 0 && !isMobile(900)) {
            
            const cardsHeight = $('.homeHero .cards').outerHeight();

            // Apply height
            $('.heroSlider .swiper-slide .sliderImage .image_holder').css({
                'height': cardsHeight + 'px',
                'padding-top': '0'
            });
        
        }
    };

    // 1. Run on Page Load
    adjustHeroHeight();

    // 2. Run on Screen Resize
    $(window).on('resize', function() {
        adjustHeroHeight();
    });

    //Copy recipe URL to clipboard
    $('.js-copy-url-clipboard').on('click', function(e) {
        e.preventDefault();
        
        const currentUrl = window.location.href;
    
        // Method 1: Modern Clipboard API (Requires HTTPS)
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(currentUrl).then(function() {
                // Success
                if (typeof showToast === 'function') {
                    showToast(`<h4 class="red">Recipe URL</h4><p>Link copied to clipboard</p>`);
                }
            }).catch(function(err) {
                console.error('Failed to copy url: ', err);
            });
        } 
        // Method 2: Fallback for older browsers or HTTP
        else {
            const $tempInput = $("<input>");
            $('body').append($tempInput);
            $tempInput.val(currentUrl).select();
            
            try {
                document.execCommand("copy");
                if (typeof showToast === 'function') {
                    showToast(`<h4 class="red">Recipe URL</h4><p>Link copied to clipboard</p>`);
                }
            } catch (err) {
                console.error('Fallback copy failed', err);
            }
            
            $tempInput.remove();
        }
    });

    $('.js-print-recipe').on('click', function(e) {
        e.preventDefault();
    
        // --- 1. SETTINGS: Map these to your LIVE page class names ---
        // Look at your main website HTML (not the print area)
        const selectors = {
            mainImage:  '.recipe_image img',     // The main recipe image
            title:      'h1',                     // The main title
            desc:       '.description',           // The description text
            time:       '.cooking-time-value',    
            servings:   '.servings-value',        
            directions: '.directions-container'   
        };
    
        // --- 2. GET DATA FROM LIVE PAGE ---
        const imgSrc = $(selectors.mainImage).attr('src'); 
        const title = $(selectors.title).text().trim(); 
        const desc = $(selectors.desc).text().trim();
        
        // We try to grab text from the live page. 
        const liveTime = $(selectors.time).text().trim();
        const liveServings = $(selectors.servings).text().trim();
        console.log('imgSrc', imgSrc)
        // --- 3. INJECT INTO PRINT AREA ---
        
        $('#print-image').attr('src', imgSrc);
        $('#print-title').text(title);
        $('#print-description').text(desc);
    
        // Only overwrite Django data if we actually found data on the live page
        if (liveTime) {
            $('#print-time').text('Cook Time: ' + liveTime);
        }
        if (liveServings) {
            $('#print-servings').text('Servings: ' + liveServings);
        }
    
        // --- 4. HANDLE INGREDIENTS (Keep this, it works) ---
        const $ingBody = $('#print-ingredients-body');
        $ingBody.empty();
        $('.live-ingredients-list .ingredient-item').each(function() {
            const name = $(this).find('.name').text().trim();
            const qty = $(this).find('.qty').text().trim();
            $ingBody.append(`
                <tr>
                    <td class="ing-name" width="50%">${name}</td>
                    <td class="ing-qty" width="50%">${qty}</td>
                </tr>
            `);
        });
    
        // --- 5. HANDLE DIRECTIONS (The Fix) ---
        const $printDirList = $('#print-directions-list');
        const liveDirectionsHtml = $(selectors.directions).html();
        
        if (liveDirectionsHtml) {
            // If we found live directions, use them
            $printDirList.html(liveDirectionsHtml);
        } 
        // If we didn't find live directions, we leave the {% placeholder %} content alone!
    
        // --- 6. MOVE & PRINT ---
        $('body').append($('#recipe-print-area'));
        window.print();
    });

    
    $('.js-download-invoice').on('click', function(e) {
        e.preventDefault();

        const $invoice = $('.invoice_page');
        
        // 1. Move invoice to body tag ensures it isn't hidden by parent containers
        $('body').append($invoice);

        // 2. Hide all other direct children of body
        $('body > *').not($invoice).hide();

        // 3. Show the invoice
        $invoice.show();

        // 4. Trigger Print
        // The browser will pause here until the user cancels or prints
        window.print();

        // 5. Restore the page
        // The cleanest way to restore the original view after printing is to reload
        window.location.reload();
    });

    $('.js-open-ingredients-list').on('click', function(e){
        e.preventDefault();
        $('.buy_recipe_ingredients').addClass('open');
        $('body').addClass('locked');
    });
    $('.js-close-ingredients-list').on('click', function(e){
        e.preventDefault();
        $('.buy_recipe_ingredients').removeClass('open');
        $('body').removeClass('locked');
    });

    $('.js-select-this-ingredient').on('click', function(e){
        e.preventDefault();
        const ingredient = $(this).closest('.recipe-product');

        ingredient.toggleClass('selected-ingredient');
    });
});